import { render, staticRenderFns } from "./PureHeader.vue?vue&type=template&id=bca10016&scoped=true&"
import script from "./PureHeader.vue?vue&type=script&lang=js&"
export * from "./PureHeader.vue?vue&type=script&lang=js&"
import style0 from "./PureHeader.vue?vue&type=style&index=0&id=bca10016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca10016",
  null
  
)

export default component.exports